export const MESSAGE_EMBED_AUTH_TOKEN = 'MESSAGE_EMBED_AUTH_TOKEN';
export interface MessageEmbedAuthToken {
  type: typeof MESSAGE_EMBED_AUTH_TOKEN;
  token: string;
}
